/* eslint-disable */
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';
import { logout, sendContactRequest } from '../../actions/user';

import Body from '../../components/Body';
import DashboardHeader from '../../components/DashboardHeader';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import TextField from '../../components/TextField';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';

let styles;
const BACKGROUND_ASSET = require('./background.jpg');

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageSent: false,
      errorMessage: false,
    };

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
    this.sendMessage = this.sendMessageHandler.bind(this);
    this.setValue = this.updateTextField.bind(this);
  }

  updateTextField(key, value) {
    this.setState({
      [key]: value,
    });
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(
      updateAppState({
        login_modal_open: true,
      }),
    );
  }

  sendMessageHandler(e) {
    e.preventDefault();

    this.props
      .dispatch(
        updateAppState({
          loading: true,
          loading_text: 'Sending...',
        }),
      )
      .then(() => {
        this.props
          .dispatch(
            sendContactRequest({
              name: this.state.name,
              email: this.state.email,
              subject: this.state.subject,
              message: this.state.message,
            }),
          )
          .then(response => {
            console.log('response', response);

            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );

            if (response.status === 200) {
              this.setState({
                messageSent: true,
              });
            } else {
              this.setState({
                messageSent: false,
                errorMessage: response.data.error,
              });
            }
          });
      });
  }

  render() {
    return (
      <Body hasFooter>
        <SEO
          title="Contact Us"
          description="Get in touch with The Dog Share Collective team. We're here to help with any questions about dog sharing, memberships, or platform support."
          keywords="contact us, dog share support, customer service, help center"
          url="https://www.thedogsharecollective.com/contact"
        />
        {this.props.user.isAuthenticated ? (
          <DashboardHeader
            logoutHandler={this.logoutHandler}
            redirectHandler={this.redirectHandler}
            {...this.props}
          />
        ) : (
          <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
        )}
        <div className={css(styles.container)}>
          {this.state.messageSent ? (
            <div className={css(styles.contact_box)}>
              <h1 className={css(styles.title)}>Thanks!</h1>
              <p className={css(styles.content)}>
                {"Your message has been sent, we'll be in touch soon!"}
              </p>
            </div>
          ) : (
            <div className={css(styles.contact_box)}>
              <h1 className={css(styles.title)}>Send us a message</h1>
              <p className={css(styles.content)}>
                Give us something to work with - throw us a bone!
                <br />
                Our Member Support Team will be happy to assist you.
              </p>
              {this.state.errorMessage ? (
                <p className={css(styles.error_box)}>{this.state.errorMessage}</p>
              ) : null}
              <form className={css(styles.form)}>
                <TextField
                  id="name"
                  name="name"
                  label="Name"
                  value={this.state.name}
                  handler={this.setValue}
                />
                <TextField
                  id="email"
                  name="email"
                  email
                  label="Email"
                  value={this.state.email}
                  handler={this.setValue}
                />
                <TextField
                  id="subject"
                  name="subject"
                  label="Subject"
                  placeholder="What is this enquiry about?"
                  fullWidth
                  value={this.state.subject}
                  handler={this.setValue}
                />
                <TextField
                  id="message"
                  name="message"
                  label="Message"
                  placeholder="What did you want to say?"
                  textArea
                  fullWidth
                  value={this.state.message}
                  handler={this.setValue}
                />
                <div className={css(styles.submit_container)}>
                  <button className={css(styles.submit)} onClick={this.sendMessage}>
                    Send enquiry
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
        <Footer {...this.props} />
      </Body>
    );
  }
}

Contact.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 'calc(100vh - 240px)',
    paddingTop: 127,
    paddingBottom: 91,
    backgroundImage: `url('${BACKGROUND_ASSET}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    [Theme.mobile_query]: {
      marginTop: 80,
      paddingTop: 209,
      paddingBottom: 0,
      backgroundPosition: 'top center',
      backgroundSize: 'auto 209px',
      backgroundImage: 'url(/images/contact_bg_mob.jpg)',
    },
  },
  error_box: {
    color: Theme.red,
    paddingBottom: 40,
  },
  contact_box: {
    width: 760,
    margin: '0 auto',
    padding: 60,
    backgroundColor: Theme.white,

    [Theme.mobile_query]: {
      width: '100%',
      padding: '60px 20px',
    },
  },
  title: {
    marginBottom: 30,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'center',
  },
  content: {
    width: 631,
    margin: '0 auto 50px',
    fontFamily: Theme.font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.4,
    textAlign: 'center',
    color: '#000e1f',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -5px',
  },
  submit_container: {
    width: '100%',
    padding: '0 5px',
    textAlign: 'right',
  },
  submit: {
    width: 206,
    height: 50,
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: Theme.white,
    borderRadius: 5,
    border: 0,
    backgroundColor: Theme.primary,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#61c3df',
    },

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/views/Contact/index.js